import { render, staticRenderFns } from "./Ofx.vue?vue&type=template&id=3e3b0c32"
import script from "./Ofx.vue?vue&type=script&lang=js"
export * from "./Ofx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports